import React from 'react';
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor';
import {TagSmall} from '@wix/wix-ui-icons-common';
import {useControllerProps} from '../../../domain/controllers/ControllerContext';
import s from './Discounts.scss';
import {TotalUpdateSkeleton} from '../../../components/cart/Widget/Components/OrderSummary/SubTotals/TotalUpdateSkeleton';
import {DiscountModel} from '../../../domain/models/CartSummary/Discount.model';
import {TotalGroup} from '../TotalGroup/TotalGroup';

export enum DiscountsDataHook {
  Root = 'Discounts.DiscountsRoot',
  DiscountIcon = 'Discounts.DiscountsIcon',
  DiscountLabel = 'Discounts.DiscountsLabel',
  DiscountValue = 'Discounts.DiscountsDiscountValue',
}

export interface DiscountsProps {
  shouldShowDivider?: boolean;
}

export const Discounts = ({shouldShowDivider}: DiscountsProps) => {
  const {t} = useTranslation();
  const {isRTL} = useEnvironment();
  const {cartSummary, isSummaryUpdating} = useControllerProps().cartStore;
  const globalDiscounts = cartSummary.globalDiscounts;

  const getDiscountRowValueText = (discount: DiscountModel): string => {
    const totalAmountOff = discount.totalAmountOff;

    if (isRTL) {
      return `${totalAmountOff}-`;
    }
    return `-${totalAmountOff}`;
  };

  const totals = globalDiscounts.map((discount) => ({
    title: discount.name,
    value: isSummaryUpdating ? () => <TotalUpdateSkeleton /> : getDiscountRowValueText(discount),
    key: discount.name,
    labelPrefix: <TagSmall aria-hidden data-hook={DiscountsDataHook.DiscountIcon} className={s.discountIcon} />,
    className: s.discountRow,
    additionalAttributes: {
      'data-wix-coupon-discount-value': DiscountsDataHook.DiscountValue,
    },
  }));

  const shouldShowBottomDivider = shouldShowDivider && totals.length > 1;

  return (
    <div className={shouldShowBottomDivider ? s.bottomDivider : undefined}>
      <TotalGroup dataHook={DiscountsDataHook.Root} totals={totals} title={t('cart.Discounts')} />
    </div>
  );
};
